import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AppProviders } from './context/AppContext';
import Layout from './components/layout/Layout';
import RequireAuth from './components/common/RequireAuth';

// Pages
import HomePage from './pages/HomePage';
import ArticlePage from './pages/ArticlePage';
import CategoryPage from './pages/CategoryPage';
import SearchPage from './pages/SearchPage';
import EditionsPage from './pages/EditionsPage';
import EditionDetailPage from './pages/EditionDetailPage';
import AuthorPage from './pages/AuthorPage';
import NotFoundPage from './pages/NotFoundPage';

import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import AdminPage from './pages/AdminPage';
import ArticleEditorPage from './pages/ArticleEditorPage';
import EditionEditorPage from './pages/EditionEditorPage';
import MagazineViewPage from './pages/MagazineViewPage';
import CategoryEditorPage from './pages/CategoryEditorPage';
import PrivacidadPage from './pages/PrivacidadPage';
import TerminosPage from './pages/TerminosPage';

// Styles
import './styles/globals.css';
// NewspaperLanding (landing SaaS de PressFlow) queda en el repo pero
// desligada del router principal. Si en el futuro se quiere volver a
// exponer como página comercial, reimportarla y montarla en otra ruta
// (ej. '/comercial').
// import NewspaperLanding from './pages/NewspaperLanding';

function App() {
  return (
    <AppProviders>
      <BrowserRouter>
        <Routes>
          {/* La raíz muestra directamente la home del periódico (Layout + HomePage). */}
          <Route path="/" element={<Layout />}>
            {/* ── Rutas públicas del periódico ───────────────────── */}
            <Route index element={<HomePage />} />
            <Route path="privacidad" element={<PrivacidadPage />} />
            <Route path="terminos" element={<TerminosPage />} />
            <Route path="articulo/:slug" element={<ArticlePage />} />
            <Route path="seccion/:slug" element={<CategoryPage />} />
            <Route path="buscar" element={<SearchPage />} />
            <Route path="ediciones" element={<EditionsPage />} />
            <Route path="ediciones/:number" element={<EditionDetailPage />} />
            <Route path="autor/:id" element={<AuthorPage />} />
          </Route>

          {/* ── Rutas de administración ────────────────────────────
              Fuera del Layout público: el panel admin tiene su
              propio chrome (sidebar + main) y no debe compartir el
              header del sitio (topbar + navbar del periódico), que
              tapaba el sidebar y ocultaba el botón Dashboard. */}
          <Route path="/admin"                     element={<RequireAuth><AdminPage /></RequireAuth>} />
          <Route path="/admin/articulo/nuevo"      element={<RequireAuth><ArticleEditorPage /></RequireAuth>} />
          <Route path="/admin/articulo/editar/:id" element={<RequireAuth><ArticleEditorPage /></RequireAuth>} />
          <Route path="/admin/edicion/nueva"       element={<RequireAuth><EditionEditorPage /></RequireAuth>} />
          <Route path="/admin/edicion/editar/:id"  element={<RequireAuth><EditionEditorPage /></RequireAuth>} />
          <Route path="/admin/categoria/nueva"     element={<RequireAuth><CategoryEditorPage /></RequireAuth>} />
          <Route path="/admin/categoria/editar/:id" element={<RequireAuth><CategoryEditorPage /></RequireAuth>} />

          {/* ── Vista de revista de una edición ──────────────────────
              Fuera del Layout público: la revista ocupa toda la
              pantalla (fondo oscuro, sin header/footer) para dar
              sensación de publicación digital inmersiva. */}
          <Route path="/edicion/:id/revista" element={<MagazineViewPage />} />

          {/* Compat: cualquier link viejo a /app/* sigue funcionando redirigiendo a la raíz. */}
          <Route path="/app" element={<Navigate to="/" replace />} />
          <Route path="/app/*" element={<Navigate to="/" replace />} />

          {/* Auth fuera del Layout para que la pantalla sea limpia (sin header/footer del diario). */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />

          {/* 404 */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </BrowserRouter>
    </AppProviders>
  );
}

export default App
